export const DELETE_PROCESS_STATEMENT_COMMENT_REQUEST = 'DELETE_PROCESS_STATEMENT_COMMENT_REQUEST';

export const deleteProcessStatementCommentRequest = (processStatementId, processStatementComment) => ({
    type   : DELETE_PROCESS_STATEMENT_COMMENT_REQUEST,
    payload: {
        processStatementId,
        processStatementComment
    }
});
